import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import SocialUpdate from "../social_update";
import SocialUpdateBody from "../social_update_body";
import BookCoverRow from "../shared/book_cover_row";
import ExpandableHtml from "../../user_content/expandable_html";

export default GrComponentFactory.createClass({
  displayName: "ReadingYearNewsfeedItem",

  propTypes: {
    resource: React.PropTypes.shape({
      user: GrPropTypes.user().isRequired,
    }),
    imageUrl: React.PropTypes.string.isRequired,
    yearInBooksUrl: React.PropTypes.string.isRequired,
    year: React.PropTypes.number.isRequired,
    numRead: React.PropTypes.number.isRequired,
    books: React.PropTypes.arrayOf(GrPropTypes.book()).isRequired,
    updateText: React.PropTypes.string.isRequired,
    yearlyBlurb: React.PropTypes.shape(GrPropTypes.expandableHtml()),
  },

  renderHeader() {
    return <span>
      shared their&nbsp;
      <a href={this.props.yearInBooksUrl}
        className="gr-hyperlink gr-hyperlink--bold">
        Year in Books {this.props.year}
      </a>
    </span>;
  },
  renderBlurb() {
    if (this.props.yearlyBlurb) {
      return <div className="readingYearBlurb">
        <ExpandableHtml {...this.props.yearlyBlurb} />
       </div>;
    }
    else {
      return null;
    }
  },

  renderBody() {
    const user = this.props.resource.user;
    const imageProps = {
      url: this.props.imageUrl,
      linkUrl: this.props.yearInBooksUrl,
      altText: `See ${user.viewableName}'s year in books`,
    };
    return <SocialUpdateBody image={imageProps}
      imageClass="gr-newsfeedItem__readingYearBadge">
      <div className="gr-newsfeedItem__details">
        {this.props.updateText}
      </div>
      <BookCoverRow numBooksRead={this.props.numRead}
        books={this.props.books}
        url={this.props.yearInBooksUrl} />
      {this.renderBlurb()}
      <a href={this.props.yearInBooksUrl}
        className="gr-button">
        Check out {user.viewableName}'s Year in Books
      </a>
    </SocialUpdateBody>;
  },

  render() {
    return <SocialUpdate
      header={this.renderHeader()}
      body={this.renderBody()}
      {...this.props}
    />;
  },
});
